export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-default-6662720f104563f0d331a9ba9b985800.mp4";